<aside
  class="sidebar"
  [class.is-collapsed]="collapsed"
  [class.is-mobile-open]="mobileOpen"
>
  <nav class="sidebar__nav">
    <div class="sidebar__search">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        placeholder="Buscar no menu"
        [(ngModel)]="termoBusca"
        (input)="atualizarBusca()"
      />
    </div>

    @if (buscaSemResultados) {
      <div class="sidebar__empty">Nenhum módulo encontrado.</div>
    }

    @for (grupo of gruposFiltrados; track grupo.titulo) {
      <button class="sidebar__header" type="button" (click)="alternarGrupo(grupo)">
        <span class="sidebar__title">{{ grupo.titulo }}</span>
        <i
          class="pi sidebar__toggle"
          [ngClass]="isGrupoExpandido(grupo) ? 'pi-chevron-down' : 'pi-chevron-right'"
        ></i>
      </button>

      @if (isGrupoExpandido(grupo)) {
        <div class="sidebar__group">
          @for (item of grupo.itens; track item.rota) {
            <a
              class="nav-item"
              [routerLink]="item.rota"
              routerLinkActive="is-active"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="onItemSelect()"
            >
              <i class="pi" [ngClass]="item.icon"></i>
              <span class="nav-item__label">{{ item.label }}</span>
            </a>
          }
        </div>
      }
    }
  </nav>
</aside>
